module.exports = __webpack_public_path__ + "img/DualR.755c082e.png";